module.exports = __webpack_public_path__ + "static/media/avatar.bec60cd0.svg";